




























































































































































































































































import { Component } from 'vue-property-decorator'
import { ProjectDto } from '@/models/dtos/projectDto'
import { ProjectService as _projectService } from '@/services/project.service'
import { UserService as _userService } from '@/services/user.service'
import { WorkbookService as _workbookService } from '@/services/workbook.service'
import { UserDto } from '@/models/dtos/userDto'
import { mixins } from 'vue-class-component'
import { UserMixin } from '@/mixins/userMixin'
import { ProjectMixin } from '@/mixins/projectMixin'
import { TemplateDto } from '@/models/dtos/templateDto'
import { TemplateService as _templateService } from '@/services/template.service'
import { PaginationDto } from '@/models/dtos/paginationDto'
import { PagedResponseDto } from '@/models/dtos/pagedResponseDto'
import { WorkbookEntryDto } from '@/models/dtos/workbookEntryDto'
import WorkbookEntryModal from '@/modals/WorkbookEntry.modal.vue'
import { ProjectAttachmentDto } from '@/models/dtos/projectAttachmentDto'
import ProjectFileUploadModal from '@/modals/ProjectFileUpload.modal.vue'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import { AuthService as _authService } from '@/services/auth.service'
import { EUserRole } from '@/models/dtos/enums/eUerRole'
import router from '@/router'
import { ProjectStatisticsDto } from '@/models/dtos/projectStatisticsDto'
import { WorkbookEntryFiltersDto } from '@/models/dtos/workbookEntryFiltersDto'
import DatePicker from 'vue2-datepicker'

@Component({
  components: {
    WorkbookEntryModal,
    ProjectFileUploadModal,
    DatePicker
  }
})
export default class ProjectDetails extends mixins(UserMixin, ProjectMixin) {
  // Data
  private project: ProjectDto | null = null
  private workbookEntries: PagedResponseDto<WorkbookEntryDto> | null = null
  private attachments: ProjectAttachmentDto[] = []
  private currentUser: UserInfoDto | null = null
  private projectStats: ProjectStatisticsDto | null = null
  private filters: WorkbookEntryFiltersDto = { name: '', startDate: null, endDate: null }

  private users: UserDto[] | null = null
  private pagination: PaginationDto = { pageNumber: 1, pageSize: 15 }

  // Methods
  // Entries
  private async getProjectEntries() {
    if (!this.project?.id) throw new Error('Cannot get project entries!')

    this.workbookEntries = await _workbookService.getProjectEntries(this.project.id, this.pagination.pageNumber, this.pagination.pageSize, this.filters)
  }

  private async getProjectStats() {
    if (!this.project?.id) throw new Error('Cannot get project entries!')

    this.projectStats = await _projectService.getProjectStats(this.project.id)
  }

  private addWorkbookEntry() {
    this.$root.$emit('show-workbook-entry-modal', null, this.project!.id)
  }

  private editWorkbookEntry(entry: WorkbookEntryDto) {
    this.$root.$emit('show-workbook-entry-modal', entry)
  }

  private async removeWorkbookEntry(entryId: string) {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten wpis', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderClose: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _workbookService.removeWorkbookEntry(entryId)
      await this.getProjectEntries()
    }
  }

  private canManageWorkbookEntry(entry: WorkbookEntryDto): boolean {
    return entry.accountId === this.currentUser?.id ||
          this.currentUser?.roles.includes(EUserRole.Admin) ||
          this.project?.supervisorId === this.currentUser?.id
  }

  private clearFilters() {
    this.filters = {
      startDate: null,
      endDate: null,
      name: ''
    }

    this.getProjectEntries()
  }

  // Project
  private async removeProject() {
    let confirm = false
    try {
      confirm = await this.$bvModal.msgBoxConfirm('Czy na pewno chcesz usunąć ten projekt', {
        title: 'Potwierdzenie',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'Usuń',
        cancelTitle: 'Anuluj',
        hideHeaderClose: false,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
    } catch (e) {}

    if (confirm) {
      await _projectService.removeProject(this.project!.id!)
      router.push('/')
    }
  }

  // Attachments
  private async getAttachments() {
    if (!this.project?.id) throw new Error('Cannot get project entries!')

    this.attachments = await _projectService.getProjectAttachments(this.project.id)
  }

  private showAttachmentModal() {
    this.$root.$emit('show-project-file-upload-modal', this.project!.id)
  }

  private async downloadAttachment(attachmentId: string) {
    _projectService.donwloadAttachment(attachmentId)
  }

  // Getters
  private get isLoaded() {
    return !this.project || !this.users || !this.projectStats
  }

  private get isAdmin() {
    return this.currentUser?.roles.includes(EUserRole.Admin)
  }

  // Lifecycle
  async created() {
    _authService.currentUser().subscribe(userInfo => {
      this.currentUser = userInfo
    })

    this.project = await _projectService.getProject((this.$route.params as any).id)
    this.users = await _userService.getUsers()

    this.getProjectEntries()
    this.getAttachments()
    this.getProjectStats()
  }
}
